module.exports = __webpack_public_path__ + "static/distances-80a881a2aaa21efb574a8409fba32c81.jpg";